<template>
  <form method="dialog">
    <button
      :aria-label="$t('reader.close')"
      class="button flex justify-center items-center cursor-pointer rounded-full"
    >
      <span aria-hidden class="material-icons">close</span>
    </button>
  </form>
</template>
<style scoped>
form {
  display: flex;

  height: -moz-fit-content;
  width: -moz-fit-content;

  height: fit-content;
  width: fit-content;
}

button {
  border: 2px solid transparent;
}
</style>
